module.exports = __webpack_public_path__ + "static/media/bribery-act-1.883495c1.jpg";